// import Image from "next/image";
// import { usePathname } from "next/navigation";
// import Link from "next/link";
import { Link, useLocation } from "react-router-dom";
import { ReactElement } from "react";

interface IMenuProps {
  title: string;
  icon: string;
  href: string;
}

const Menu = ({ title, icon, href }: IMenuProps): ReactElement => {
  const location = useLocation();
  const pathname = location.pathname;
  const isActive = pathname.startsWith(href);

  const primaryColor = "rgba(33, 32, 37, 0.40)";

  return (
    <Link
      id={title.toLowerCase() + "-menu"}
      to={href}
      className={`inline-flex justify-center p-5 content-between flex-col text-white ${
        isActive ? "font-semibold" : ""
      }`}
      style={isActive ? { background: primaryColor } : {}}
    >
      <img className="h-5 w-5 self-center" src={icon} alt="Menu Icon" />
      <span className="text-base">{title}</span>
    </Link>
  );
};

export default Menu;
